export const CARD_UNLIMITED_BOOKINGS_NUMBER = 1000;
export const CARD_YEAR_IN_WEEKS = 52;



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/constants/card.constants.ts